var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 1.5,
    fill: "#515151",
    stroke: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4749 4.99995C11.4749 4.72381 11.251 4.49995 10.9749 4.49995L6.4749 4.49995C6.19876 4.49995 5.9749 4.72381 5.9749 4.99995C5.9749 5.27609 6.19876 5.49995 6.4749 5.49995L10.4749 5.49995L10.4749 9.49995C10.4749 9.77609 10.6988 9.99995 10.9749 9.99995C11.251 9.99995 11.4749 9.77609 11.4749 9.49995L11.4749 4.99995ZM5.35355 11.3284L11.3285 5.3535L10.6213 4.6464L4.64645 10.6213L5.35355 11.3284Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.d81ec784874e01f1586c289b2f470b01.svg";
export { ForwardRef as ReactComponent };